export const APP_SCREENS = {
  day: { src: "/app/deserto-giorno.jpg", alt: "Schermata del giorno nella Sfida del Deserto — app Fede & Fitness Italia" },
  journey: { src: "/app/giornata.jpg", alt: "La tua giornata: Corpo, Alimentazione, Messaggio da Dio — app Fede & Fitness Italia" },
  workout: { src: "/app/allenamento.jpg", alt: "Allenamento del giorno — app Fede & Fitness Italia" },
  home: { src: "/app/home.jpg", alt: "Schermata principale Il Tuo Tempio — app Fede & Fitness Italia" },
};

export const PhoneMockup = ({ screen = "day", className = "", glow = true }) => {
  const shot = APP_SCREENS[screen];
  return (
    <div className={`relative ${className}`} data-testid={`phone-mockup-${screen}`}>
      {glow && (
        <div className="absolute -inset-8 rounded-full bg-gold/10 blur-3xl" aria-hidden="true" />
      )}
      <div className="relative mx-auto aspect-[9/19] w-full max-w-[280px] rounded-[2.2rem] border border-ivory/15 bg-charcoal p-2 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.9)]">
        <div className="relative h-full w-full overflow-hidden rounded-[1.7rem] border border-ivory/5 bg-night">
          <img src={shot.src} alt={shot.alt} className="h-full w-full object-cover object-top" loading="lazy" />
        </div>
      </div>
    </div>
  );
};
